import call from "./call";
import { VoicesTopicStatus } from "../Enums/voices";
import {
  VoicesRadarStatus,
  VoicesTopic,
  VoicesTopicFilter,
  VoicesTopicPage,
  VoicesTopicPayload,
} from "../Models/voicesTopics";
import { voicesHeaders } from "../Helpers/voicesWorkspace";

const topicsUrl = (campaignId: number) =>
  `/v1/voices/campaigns/${campaignId}/topics/`;

export const getVoicesTopics = async (
  campaignId: number,
  filter: VoicesTopicFilter,
  limit: number,
): Promise<VoicesTopicPage> => {
  const response = await call.get<VoicesTopicPage>(topicsUrl(campaignId), {
    params: { filter, limit },
    headers: voicesHeaders(),
    snack: { error: "voices.topicsFetchError" },
  });
  return response.data;
};

export const createVoicesTopic = async (
  campaignId: number,
  data: VoicesTopicPayload,
): Promise<VoicesTopic> => {
  const response = await call.post<VoicesTopic>(topicsUrl(campaignId), data, {
    headers: voicesHeaders(),
    snack: { success: "voices.topicCreateSuccess", error: "voices.topicSaveError" },
  });
  return response.data;
};

export const updateVoicesTopic = async (
  campaignId: number,
  topicId: number,
  data: VoicesTopicPayload,
): Promise<VoicesTopic> => {
  const response = await call.put<VoicesTopic>(
    `${topicsUrl(campaignId)}${topicId}/`,
    data,
    {
      headers: voicesHeaders(),
      snack: { success: "voices.topicUpdateSuccess", error: "voices.topicSaveError" },
    },
  );
  return response.data;
};

export const setVoicesTopicStatus = async (
  campaignId: number,
  topicId: number,
  status: VoicesTopicStatus,
): Promise<VoicesTopic> => {
  const response = await call.put<VoicesTopic>(
    `${topicsUrl(campaignId)}${topicId}/status/`,
    { status },
    { headers: voicesHeaders(), snack: { error: "voices.topicStatusError" } },
  );
  return response.data;
};

export const deleteVoicesTopic = async (
  campaignId: number,
  topicId: number,
): Promise<void> => {
  await call.delete(`${topicsUrl(campaignId)}${topicId}/`, {
    headers: voicesHeaders(),
    snack: { success: "voices.topicDeleteSuccess", error: "voices.topicDeleteError" },
  });
};

const radarUrl = (campaignId: number) => `/v1/voices/campaigns/${campaignId}/radar/`;

export const startVoicesRadar = async (campaignId: number): Promise<VoicesRadarStatus> => {
  const response = await call.post<VoicesRadarStatus>(
    radarUrl(campaignId),
    {},
    {
      headers: voicesHeaders(),
      snack: { success: "voices.radarStartSuccess", error: "voices.radarStartError" },
    },
  );
  return response.data;
};

export const getVoicesRadarStatus = async (
  campaignId: number,
): Promise<VoicesRadarStatus> => {
  const response = await call.get<VoicesRadarStatus>(radarUrl(campaignId), {
    headers: voicesHeaders(),
  });
  return response.data;
};
